import { useEffect, useState } from "react";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../theme/Component/BasicTable";
import { ListMenu } from "../../theme/Component/ListMenu";
import { CardTaps } from "../../theme/Component/CardTaps";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _AdquisitionItem, _Inbox, _single } from "../../../core/services/dataBean/EntityCatalog";
import { SelectFunctionalID } from "../../admin/configuracion/functionalID/SelectFunctionalID";
import { ModalGeneric } from "../../../interfaces";
import { CardTramitesHistory } from "../config/InfoTramiteComponents/HistoryImp/CardTramitesHistory";
import { Modal } from "../../theme/Component/Modal";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { Alert } from "../../theme/Component/Alert";
import { BPMInboxAssigned } from "./BPMInboxAssigned";
import { SelectGroupMemberAssigned } from "../../theme/Component/SelectGroupMemberAssigned";
import { SelectGroupMemberTable } from "./SelectGroupMember/SelectGroupMemberTable";
import { MODAL_LG } from "../../theme/Component/hooks/useModal";
import { BPMRequestProcedureType } from "../RequestProcedure/BPMRequestProcedureType";
import { HandlerInfoProcess } from "../config/InfoTramiteComponents/HandlerInfoProcess";
import { PrintJson } from "../../theme/Component/PrintJson";
import { toast } from "react-toastify";
import usePaginator from "../../theme/Component/usePaginator";
import { single } from "rxjs";
import { AtachDocument } from "../../theme/Component/AtachDocument";
interface Props {
    isAdmin?: boolean;
}
export const BPMInbox = ({ isAdmin }: Props) => {

    // const testMode = env.PRINT_LOG ?? false;
    const testMode = isAdmin ?? false;
    const paginador = usePaginator();
    const { instance, lista, setLista, bean, setBean } = useDataBean(_Inbox);
    const [area, setArea] = useState<any>({});
    const [indexTap, setIndexTap] = useState(0);
    const [asignedRolID, setAsignedRolID] = useState<number[] | null>(null);
    const [user, setUser] = useState<any>({});
    const [obs, setObs] = useState<string>("");

    const [modalAutoAssing, setModalAutoAssing] = useState<ModalGeneric>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modalHistory, setModalHistory] = useState<ModalGeneric>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: MODAL_LG });
    const [modalAssing, setModalAssing] = useState<ModalGeneric>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalReques, setModalRequest] = useState<ModalGeneric>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalCancel, setModalCancel] = useState<ModalGeneric>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });


    let taps = [
        { id: 0, name: 'Sin Asignar', disable: false },
        { id: 1, name: 'Por Gestión', disable: false }
    ];

    const isBoss = Boolean(area?.IDLn && _single.getIDBossGroupAssingned(area.IDLn) === _single.getAccountID());

    useEffect(() => {
        setLista([]);

        if (!area?.IDLn) {
            setAsignedRolID(null);
            return;
        }

        getRoles();

    }, [area?.IDLn, area?.IDWorkGroupMember])

    useEffect(() => {
        if (indexTap !== 0 || !area?.IDLn) return;
        if (!isBoss && !testMode && asignedRolID === null) return;

        getLista();

    }, [area?.IDLn, paginador.page, indexTap, asignedRolID])

    const getLista = () => {
        if (!area?.IDLn) {
            setLista([]);
            return;
        }

        instance.getListBpmInboxForAssing(area.IDLn, isBoss ? [] : (asignedRolID ?? []), [6], 0, paginador.page, 15).then(
            (resp) => {
                paginador.setPages(resp.NumberOfPages);
                setLista(resp.List)
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const getRoles = () => {
        if (!area?.IDWorkGroupMember) {
            setAsignedRolID([]);
            return;
        }

        instance.getWorkGroupRoleCatalog(area.IDWorkGroupMember).then(
            (resp) => {
                let list = [];
                let x = resp;
                x.map((item) => {
                    list.push(item.DataBeanProperties.IDBusinessRole)
                })
                setAsignedRolID(list)
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const assingProcedure = (idaccount: number) => {
        instance.assignProcedureImpToGroupMember(bean.IDProcedureImp, idaccount, _single.getAccountID()).then(
            (resp) => {
                getLista();
                setModalAssing({ ...modalAssing, "view": false });
                setModalAutoAssing({ ...modalAutoAssing, "view": false });
            }
        )
    }

    const head = [
        { title: 'Tramite', property: 'AlphaCode', visible: true },
        { title: 'Procedimiento', property: 'ProcedureName', visible: true },
        { title: 'Solicitud', property: 'Description', visible: true },
        { title: 'Paso actual', property: 'ProcedureStep', visible: true },
        { title: 'Fecha ultima Modificación', property: 'LastDateStage', visible: true },
        { title: 'Rol de Ejecución', property: 'RolName', visible: true },
        { title: 'Gestion de', property: 'EntityNameAction', visible: true },

    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Historico', icono: 'ri-edit-2-line', visible: true, evento: () => { setModalHistory({ ...modalHistory, "view": true, "name": "Historico del Procedimiento" }) } },
            { titulo: 'Auto Asignar', icono: 'ri-user-follow-line', visible: (bean.IDEmployeeImp ? false : true), evento: () => { setModalAutoAssing({ ...modalAutoAssing, "view": true, "name": "AutoAsignar el Procedimiento" }) } },
            // { titulo: 'Asignar a alguien', icono: 'ri-team-line', visible: isBoss && bean.IDEmployeeImp ? false : true, evento: () => { setModalAssing({ ...modalAssing, "view": true, "name": "Asignar procedimiento" }) } },
            { titulo: 'Cancelar Tramite', icono: 'ri-close-circle-line', visible: isBoss && bean.IDEmployeeImp ? false : true, evento: () => { setModalCancel({ ...modalCancel, "view": true, "name": "Confirmar Cancelación del tramite" }); setObs("") } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const iconButtonsItem = [
        { nombre: 'Solicitar', visible: true, icono: 'ri-file-add-line', evento: () => { setModalRequest({ ...modalReques, view: true, name: "Nueva Solicitud" }) } }
    ]

    const deleteProcedureImp = () => {
        instance.cancelProcedureImp(bean.IDProcedureImp, _single.getAccountID(), obs).then(
            (resp: any) => {
                toast.success("Se ha realizado la accion");
                getLista();
                setModalCancel({ ...modalCancel, "view": false });
                pushResumeInfo(obs)
            }
        ).catch(
            err => {
                console.log(err);
                toast.error("No se pudo realizar la acción")
            }
        )
    }

    const pushResumeInfo = (objeto: any) => {
        instance.pushResumeBpm(bean.IDProcedureImp, _single.getAccountID(), `${objeto} - Paso de Cancelación: ${bean.ProcedureStep}`, { disableSpinner: true }).then(
            (resp) => {
                setObs("");
            }
        ).catch(err => { console.log("Error en actualizar la tabla", err) })
    }

    return (
        <BasicPage titulo={`Bandeja de Auto Gestion - Area`}>
            <div className="row">

                <div className="col-md-12">
                    <CardTaps index={indexTap} taps={taps} updateIndex={setIndexTap} >

                        {indexTap === 0 &&
                            <div className="row">
                                <div className="col-md-12">
                                    {testMode ?
                                        <div className="col-md-6">
                                            <SelectFunctionalID functionalIDLn={area?.IDLn} label="Area" onChange={(area: any) => { paginador.setPage(1); setArea(area) }} />
                                        </div>
                                        :
                                        <div className="col-md-6">
                                            <SelectGroupMemberAssigned idSelector={area?.IDLn} onChange={(area: any) => { paginador.setPage(1); setArea(area ?? {}) }} returnType="Object" />
                                        </div>
                                    }
                                </div>
                                {area?.IDLn ?
                                    <div className="col-md-12">
                                        <BasicTable iconButtons={iconButtonsItem} body={lista} head={head} rowSet={setBean} listButtons={listaBotones()}
                                            pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador}
                                        />
                                    </div>
                                    :
                                    <div className="row">
                                        <div className="col-md-12 text-center">
                                            <Alert children={"No se encuentra asignado a un area"} clase="danger" />
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                        {indexTap === 1 &&
                            <div className="row">
                                <div className="col-md-12">
                                    <BPMInboxAssigned />
                                </div>
                            </div>
                        }
                    </CardTaps>
                </div>

                <div className="col-md-12">
                    <Modal modal={modalHistory} updateModal={setModalHistory} >
                        <HandlerInfoProcess _ProcedureIMPID={bean.IDProcedureImp} />
                    </Modal>
                </div>

                <div className="col-md-12">
                    <ModalConfirm modal={modalAutoAssing} updateModal={setModalAutoAssing} eventModal={() => { assingProcedure(_single.getAccountID()) }}>
                        <p>¿Esta seguro de Asignarse el procedimiento {bean.AlphaCode}?</p>
                    </ModalConfirm>
                </div>

                <div className="col-md-12">
                    <Modal modal={modalAssing} updateModal={setModalAssing} eventModal={() => {
                        assingProcedure(user.IDAccount)
                    }} >
                        <SelectGroupMemberTable idlnArea={area?.IDLn} onChange={setUser} />
                    </Modal>
                </div>

                <div className="col-md-12">
                    <Modal modal={modalReques} updateModal={setModalRequest} >
                        <BPMRequestProcedureType addPropsInit={area} updateFather={() => { getLista() }} />
                    </Modal>
                </div>

                <div className="col-md-12">
                    <Modal modal={modalCancel} updateModal={setModalCancel} eventModal={() => { deleteProcedureImp() }} >
                        <div className="row">
                            <div className="col-md-12">
                                <textarea rows={5} className="form-control" value={obs} onChange={(e) => { setObs(e.target.value) }} />
                            </div>
                        </div>
                    </Modal>
                </div>
            </div>
        </BasicPage>
    )
}
